import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import styles from "./page-layout.module.scss";

import Icons from "@/components/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/v2/breadcrumb";
import { ROUTES } from "@/constants/routes";
import { BreadcrumbType } from "@/types/breadcrumb-types";

type PageLayoutProps = {
  children: React.ReactNode;
  breadcrumb?: BreadcrumbType;
};

const PageLayout: React.FC<PageLayoutProps> = ({ children, breadcrumb }) => {
  if (!breadcrumb) {
    return <section className={styles.page}>{children}</section>;
  }

  const { navigation, currentPage } = breadcrumb;

  return (
    <section className={styles.page}>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to={`/${ROUTES.home}`}>
                <Icons.DashboardIcon fontSize={24} />
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {navigation?.map(({ label, url }) => (
            <Fragment key={label}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {url !== null ? (
                  <BreadcrumbLink asChild>
                    <Link to={url}>{label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{label}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
            </Fragment>
          ))}
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{currentPage.label}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      {children}
    </section>
  );
};

export default PageLayout;
